import {
  buildSectionSelector,
  normalizeSectionId
} from '@theme/section-renderer'
import { useIntersection } from '@theme/use-intersection'
import { onDocumentReady, requestIdleCallback } from '@theme/utils'

function hydrateSection(sectionId) {
  const normalizedId = normalizeSectionId(sectionId)
  const section = document.getElementById(buildSectionSelector(normalizedId))

  if (!section || section.dataset.hydrated === 'true') {
    return
  }

  section.dataset.hydrated = 'true'
}

export function hydrate(sectionId) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId))
  })
}

function setupLazySectionHydration() {
  const sectionsToLazyLoad = document.querySelectorAll('[data-lazy-section]')
  const observer = useIntersection({
    rootMargin: '200px'
  })

  sectionsToLazyLoad.forEach((section) => {
    const sectionId = section.id.replace(buildSectionSelector(''), '')
    observer.observe(section, (entry, obs) => {
      if (entry.isIntersecting) {
        obs.unobserve(section)
        hydrateSection(sectionId)
      }
    })
  })
}

onDocumentReady(setupLazySectionHydration)
